import { SVGProps } from "react";

export default function ClockIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#AC4B23", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.16927 8.83333C2.16927 12.0533 4.7826 14.6667 8.0026 14.6667C11.2226 14.6667 13.8359 12.0533 13.8359 8.83333C13.8359 5.61333 11.2226 3 8.0026 3C4.7826 3 2.16927 5.61333 2.16927 8.83333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.33325V8.66659"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.33325H6"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
